/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** BM page ID for the Side Menu Links Page PD instance (page type `sideMenuLinksPage`). */
export const SIDE_MENU_LINKS_PAGE_ID = 'side-menu-links';

/** Region for Content Block components at the bottom of the header side menu. */
export const SIDE_MENU_LINKS_REGION_ID = 'links';
